import createVanilla, { StoreApi } from "zustand/vanilla";
import create, { UseStore } from "zustand";

type ObservableSettingsStoreData = {
	isNewFeatureDialogEnabled: boolean;
	setIsNewFeatureDialogEnabled(value: boolean): void;
};

const observableSettingsStore: StoreApi<ObservableSettingsStoreData> = createVanilla<ObservableSettingsStoreData>(
	set => ({
		isNewFeatureDialogEnabled: false,
		setIsNewFeatureDialogEnabled: (value: boolean): void => {
			set({
				isNewFeatureDialogEnabled: value
			});
		}
	})
);

export const useObservableSettingsStore: UseStore<ObservableSettingsStoreData> = create(observableSettingsStore);

export const isNewFeatureDialogEnabled = {
	get value(): boolean {
		return observableSettingsStore.getState()
			.isNewFeatureDialogEnabled;
	},
	set value(value: boolean){
		observableSettingsStore.getState()
			.setIsNewFeatureDialogEnabled(value);
	}
};